const fileInit = {
  data: null,
  meta: null,
};

const filePreviewReducer = (state = fileInit, action) => {
  let newState = { ...state };

  switch (action.type) {
    case "SET_FILE_PREVIEW":
      return action.payload;

    case "SET_FILE_PREVIEW_DATA":
      newState.data = action.payload;
      return newState;

    case "SET_FILE_PREVIEW_META":
      newState.meta = action.payload;
      return newState;

    case "UPDATE_FILE_PREVIEW_META":
      newState.meta = {
        ...newState.meta,
        ...action.payload,
      };
      return newState;

    case "CLEAR_FILE_PREVIEW":
      return fileInit;

    default:
      return state;
  }
};

/**
 * ACTION CREATORS
 */

export const filePreviewSet = (file) => ({
  type: "SET_FILE_PREVIEW",
  payload: file,
});

export const filePreviewSetData = (fileData) => ({
  type: "SET_FILE_PREVIEW_DATA",
  payload: fileData,
});

export const filePreviewSetMeta = (fileMeta) => ({
  type: "SET_FILE_PREVIEW_META",
  payload: fileMeta,
});

export const filePreviewMetaUpdate = (updatedFileMetaValues) => ({
  type: "UPDATE_FILE_PREVIEW_META",
  payload: updatedFileMetaValues, // should be an object with potentially more than one keys to update. it should merge with existing meta values
});

export const filePreviewClear = () => ({
  type: "CLEAR_FILE_PREVIEW",
});

export default filePreviewReducer;
